/*eslint-disable*/
import React, { useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControl from "@material-ui/core/FormControl";
import { post } from "lib/requests";
import * as Yup from "yup";
import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useStyles = makeStyles(sectionsPageStyle);
const useStyles2 = makeStyles(headersStyle);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);
const useStylesBasics = makeStyles(basicsStyle);

export default function SectionContactUs() {
	const classes = useStyles();
	const classes2 = useStyles2();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const classesBasics = useStylesBasics();
	const [loading, setLoading] = useState(false);

	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Full Name is required"),
		phone: Yup.string()
			.required("Contact Number is required")
			.matches(/^[0-9]+$/, "Contact Number must be a number"),
		email: Yup.string()
			.required("Company Email is required")
			.email("Company Email is not valid"),
		message: Yup.string().required("Comment or Message is required"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		getValues,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Contact us", "processing...");
		try {
			await post(`/api/contactus`, formField)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Contact us", "Your message has been sent.");
						reset();
					} else {
						ErrorMessage("Contact us", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Contact us", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Contact us", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	return (
		<div
			className={classNames(classes.chooseSection, classesCSStyles.mT)}
			id="contact">
			<div className={classes.container}>
				<div className={classes.landingTitle}>
					<h2> Contact Us</h2>
				</div>
				<div
					className={classNames(classes.landingDescription, classesCSStyles.my10)}>
					Regardless of how you choose to engage with us, we offer the capabilities
					and support needed to drive sustainable growth and maximize profitability.
					Please leave your contact information, and a member of our team will reach
					out to you shortly.
				</div>
				<form onSubmit={handleSubmit(onSubmit)}>
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<img
								className={classes.landingImage}
								src="/assets/images/landing/contact_us.jpg"
								alt="contact us"
							/>
						</GridItem>
						<GridItem xs={12} sm={6} md={6}>
							<GridContainer>
								<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitleUpdate)}>
										Full Name
										<span className="text-red-600 mr-2"> * </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter name here",
											type: "text",
											...register("name"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div
										className={classNames(
											"text-red-600 text-xs ml-3 pt-1 ",
											classes2.errorLabel
										)}>
										{errors.name?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitleUpdate)}>
										Contact Number
										<span className="text-red-600 mr-2"> * </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter number here",
											type: "text",
											...register("phone"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div
										className={classNames(
											"text-red-600 text-xs ml-3 pt-1 ",
											classes2.errorLabel
										)}>
										{errors.phone?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitleUpdate)}>
										Company Email
										<span className="text-red-600 mr-2"> * </span>
									</div>
									<CustomInput
										inputProps={{
											placeholder: "Enter email here",
											type: "text",
											...register("email"),
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div
										className={classNames(
											"text-red-600 text-xs ml-3 pt-1 ",
											classes2.errorLabel
										)}>
										{errors.email?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
									<div className={classNames(classes2.labelTitleUpdate)}>
										Comment or Message
										<span className="text-red-600 mr-2"> * </span>
									</div>
									<CustomInput
										inputProps={{
											multiline: true,
											rows: 5,
											...register("message"),
											placeholder: "Enter your message",
										}}
										formControlProps={{
											fullWidth: true,
											className: classes2.formControl,
										}}
									/>
									<div
										className={classNames(
											"text-red-600 text-xs ml-3 pt-1 ",
											classes2.errorLabel
										)}>
										{errors.message?.message}
									</div>
								</GridItem>
								<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
									<button
										type="submit"
										className={classNames(
											classesCSStyles.buttonPrimary,
											classesCSStyles.my5
										)}>
										Send Message
									</button>
								</GridItem>
							</GridContainer>
						</GridItem>
					</GridContainer>
				</form>
			</div>
		</div>
	);
}
